export class InterestedCustomer {
  email: string;
  postalCode: string;
}